import { Injectable, computed, signal } from '@angular/core';

/**
 * Estado del overlay de carga global.
 * Es un contador y no un booleano: con dos requests en vuelo, la primera en terminar
 * no debe apagar el overlay mientras la segunda sigue.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly pending = signal(0);
  readonly isLoading = computed(() => this.pending() > 0);

  start(): void {
    this.pending.update((n) => n + 1);
  }

  stop(): void {
    this.pending.update((n) => Math.max(0, n - 1));
  }
}
